import moment from 'moment';

import { t } from '../../../utils/i18n/i18n';

export const SEND_MODE = { NOW: 'NOW', SCHEDULE: 'SCHEDULE' };

/**
 * `label` é CHAVE de tradução, resolvida no render (ver PushScheduleFields.jsx) — nunca
 * aqui: o arquivo de idioma só é escolhido depois do fetch de src/useApp.ts, então
 * traduzir numa constante de módulo congelaria a lista em português.
 */
export const RECURRENCE_OPTIONS = [
  { value: 'NONE', label: 'Não repetir' },
  { value: 'WEEKLY', label: 'Toda semana' },
  { value: 'MONTHLY', label: 'Todo mês' },
];

/**
 * Junta o dia escolhido no DatePicker com a hora do TimePicker num ISO com offset.
 * O offset é o do navegador, coerente com o header X-Timezone-Offset que o projeto
 * já envia (src/services/request.js:11).
 */
export const buildScheduledAt = (
  date: moment.Moment | null,
  time: moment.Moment | null,
): string | null => {
  if (!date || !time) {
    return null;
  }
  const combined = moment(date)
    .hour(moment(time).hour())
    .minute(moment(time).minute())
    .second(0)
    .millisecond(0);
  return combined.format('YYYY-MM-DDTHH:mm:ssZ');
};

export const validateScheduleFields = (values: {
  sendMode: string;
  scheduleDate: moment.Moment | null;
  scheduleTime: moment.Moment | null;
  recurrence: string;
  recurrenceUntil: moment.Moment | null;
}): Record<string, string> => {
  const errors: Record<string, string> = {};
  if (values.sendMode !== SEND_MODE.SCHEDULE) {
    return errors;
  }
  if (!values.scheduleDate) {
    errors.scheduleDate = t('Informe a data do disparo');
  }
  if (!values.scheduleTime) {
    errors.scheduleTime = t('Informe a hora do disparo');
  }
  const scheduledAt = buildScheduledAt(values.scheduleDate, values.scheduleTime);
  if (scheduledAt && moment(scheduledAt).isSameOrBefore(moment())) {
    errors.scheduleDate = t('O disparo precisa ser no futuro');
  }
  if (values.recurrence && values.recurrence !== 'NONE') {
    if (!values.recurrenceUntil) {
      errors.recurrenceUntil = t('Informe até quando repetir');
    } else if (scheduledAt
        && moment(values.recurrenceUntil).endOf('day').isBefore(moment(scheduledAt))) {
      errors.recurrenceUntil = t('A data-fim precisa ser depois do primeiro disparo');
    }
  }
  return errors;
};
